import { ServiceCatalogItem } from '../../types';

const config = { mandatory: true };

// Plain text field validator

function plaintextValidator({
  mandatory = false,
  customError = null
}: {
  mandatory: boolean;
  customError?: string;
}) {
  return {
    type: 'string',
    presence: mandatory && { message: customError }
  };
}

const sellingPriceValidation = {
  sellingPrice: {
    presence: true
  },
  'sellingPrice.details': {
    array: {
      value: plaintextValidator(config)
    }
  }
};

const packageTypeValidation = {
  'serviceTypeItem.redeemableServiceBundle.applicableType': plaintextValidator(
    config
  ),
  'serviceTypeItem.redeemableServiceBundle.applicableHours': plaintextValidator(
    config
  ),
  'serviceTypeItem.redeemableServiceBundle.redeemableQuantity': plaintextValidator(
    config
  )
};

const getServiceCatalogConstraints = ({
  serviceItem,
  productType
}: {
  serviceItem: ServiceCatalogItem;
  productType?: 'MSP' | 'IT';
}) => {
  if (productType === 'IT') {
    return {
      name: plaintextValidator(config)
    };
  }

  const baseValidation = {
    name: plaintextValidator(config),
    itemType: plaintextValidator(config),
    taxable: {
      type: 'boolean',
      presence: true
    }
  };

  let typeBasedValidation;

  switch (serviceItem?.serviceTypeItem?.offeringType) {
    case 'HOURS':
      typeBasedValidation = {
        ...sellingPriceValidation,
        'serviceTypeItem.offeringType': plaintextValidator(config)
      };
      break;
    case 'QUANTITY':
      typeBasedValidation = {
        ...sellingPriceValidation,
        'serviceTypeItem.offeringType': plaintextValidator(config)
      };
      break;
    case 'BLOCK_MONEY':
    case 'BLOCK_HOUR':
      typeBasedValidation = packageTypeValidation;
      break;
    case 'SERVICE_BUNDLE':
      typeBasedValidation = sellingPriceValidation;
      break;
    default:
      typeBasedValidation = sellingPriceValidation;
      break;
  }

  // Removing empty tax validation.
  // if (serviceItem?.taxable) {
  //   typeBasedValidation = {
  //     ...typeBasedValidation,
  //     'salesTax.taxId': plaintextValidator({
  //       mandatory: true,
  //       customError: 'Please choose a tax option'
  //     })
  //   };
  // }

  if (
    serviceItem?.serviceTypeItem?.redeemableServiceBundle?.applicableType ===
      'INCLUDED_ITEMS' ||
    serviceItem?.serviceTypeItem?.offeringType === 'SERVICE_BUNDLE'
  ) {
    typeBasedValidation = {
      ...typeBasedValidation,
      'serviceTypeItem.bundledItems': {
        length: {
          minimum: 1,
          tooShort: 'Need atleast one Service item'
        },
        array: {
          itemId: plaintextValidator(config)
        }
      }
    };
  }

  return {
    ...baseValidation,
    ...typeBasedValidation
  };
};

export { getServiceCatalogConstraints };
